import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import CarrierM39ComplianceReport from '../../components/CarrierM39ComplianceReport';
import {
  COLUMN_ACCESSOR_RECEPTACLES_TOTAL,
  PROPERTY_ORIGINAL_GRAND_TOTAL,
  getFilteredAndSortedData,
  getGeneratedOnDateTime,
  getIsLoading,
  getIsFiltered,
  getOriginalGrandTotal, getColumns,
} from '../redux/selectors/CarrierM39ComplianceLocationSelectors';
import CarrierM39ComplianceLocationReportMode from './CarrierM39ComplianceLocationReportMode';
import {
  getLeafColumns, getPropertyValueByPath, setPropertyValueByPath, deepClone,
} from '../../../../../react-table/helpers/utils';
import { getReportMode } from '../../../../common/redux/selectors/ReportsSelectors';
import {
  changeReportFiltering,
  changeReportMode,
  changeReportSorting,
} from '../../../../common/redux/actions/ReportsActions';

const MODE_TABS = [
  { value: CarrierM39ComplianceLocationReportMode.percentage, label: '%' },
  { value: CarrierM39ComplianceLocationReportMode.number, label: '#' },
];

class CarrierM39ComplianceLocationContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillUnmount() {
    // eslint-disable-next-line react/prop-types
    this.props.changeReportFiltering({
      reportDefinition: {
        id: ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_800_LOCATION.id,
      },
      sorting: {},
      filtering: {},
    });
  }

  onLocationReportSortedChange = (newSorted, column, shiftKey) => {
    // eslint-disable-next-line react/prop-types
    this.props.changeReportSorting({
      reportDefinition: {
        id: ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_800_LOCATION.id,
      },
      sorting: {
        newSorted,
        column,
        shiftKey,
      },
    });
  };

  onLocationReportFilteredChange = (column, value) => {
    this.props.changeReportFiltering({
      reportDefinition: {
        id: ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_800_LOCATION.id,
      },
      filtering: {
        appliedFilters: column,
        appliedColumn: value,
      },
    });
  };

  getColumnsWithOriginalGrandTotal() {
    const { columns } = this.props;

    const transformedColumns = deepClone(columns);

    const leafColumns = getLeafColumns(transformedColumns);
    const columnWithGrandTotalLink = leafColumns.find(column => column.accessor === COLUMN_ACCESSOR_RECEPTACLES_TOTAL);

    const originalGrandTotal = getPropertyValueByPath(columnWithGrandTotalLink, PROPERTY_ORIGINAL_GRAND_TOTAL);
    // eslint-disable-next-line react/prop-types
    if (!originalGrandTotal && this.props.isFiltered && this.props.originalGrandTotal) {
      setPropertyValueByPath(columnWithGrandTotalLink, PROPERTY_ORIGINAL_GRAND_TOTAL, this.props.originalGrandTotal);
    }

    return transformedColumns;
  }

  changeMode = (reportMode) => {
    // eslint-disable-next-line react/prop-types
    this.props.changeReportMode({
      reportDefinition: {
        id: ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_800_LOCATION.id,
      },
      reportMode,
    });
  };

  render() {
    return (<CarrierM39ComplianceReport
      reportId={ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_800_LOCATION.id}
      columns={this.getColumnsWithOriginalGrandTotal.apply(this)}
      isLoading={this.props.isLoading}
      generatedOnDateTime={this.props.generatedDateTime}
      data={this.props.data}
      modeTabs={MODE_TABS}
      changeMode={this.changeMode}
      mode={this.props.mode}
      onSortedChange={this.onLocationReportSortedChange}
      onFilteredChange={this.onLocationReportFilteredChange}
    />);
  }
}

const mapStateToProps = state => ({
  data: getFilteredAndSortedData(state),
  generatedDateTime: getGeneratedOnDateTime(state),
  isLoading: getIsLoading(state),
  columns: getColumns(state),
  mode: getReportMode(state, ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_800_LOCATION.id),
  isFiltered: getIsFiltered(state),
  originalGrandTotal: getOriginalGrandTotal.apply(this, [state]),
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    changeReportMode,
    changeReportSorting,
    changeReportFiltering,
  }, dispatch);

CarrierM39ComplianceLocationContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object),
  mode: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(CarrierM39ComplianceLocationContainer);

